export default __webpack_public_path__ + "0a38c4b245644558189b9a8f72cb98d9.png";